import { Link } from "react-router-dom";
import { Siren } from "lucide-react";
import { useContent } from "../context/ContentContext";

export const EmergencyFAB = () => {
  const { c } = useContent();
  const darurat = c("kontak_darurat", "112");
  return (
  <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-2.5" data-testid="emergency-fab">
    <a
      href={`tel:${darurat}`}
      className="fab-ring btn-pop flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-bold px-5 py-3 rounded-full shadow-xl"
      data-testid="fab-call-112"
    >
      <Siren size={18} />
      <span className="font-mono">{darurat}</span>
    </a>
    <Link
      to="/layanan#lapor"
      className="btn-pop flex items-center gap-2 bg-slate-900 hover:bg-orange-600 text-white text-sm font-semibold px-4 py-2.5 rounded-full shadow-lg"
      data-testid="fab-lapor"
    >
      Lapor Bencana
    </Link>
  </div>
  );
};
